import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SectionSubtitle, Section, SectionContent } from '../styles/sections';
import {
  BlogGrid,
  BlogCard,
  BlogImage,
  BlogCardContent,
  BlogTag,
  BlogCardTitle,
  BlogCardExcerpt,
  BlogReadMore,
} from '../styles/blog';
import {
  OverlayHeroSection,
  OverlayHeroImage,
  OverlayHeroGradient,
  OverlayHeroContent,
} from '../styles/overlayHero';

// Placeholder posts — swap for real content once the blog is live.
const featuredPost = {
  tag: 'Club Stories',
  title: 'How Thornbury FC cut admin time in half',
  excerpt: "One committee's move from spreadsheets to Playfair.",
  image: '/image2.jpg',
};

const posts = [
  {
    tag: 'Product',
    title: '5 ways to keep team fines fair',
    excerpt: 'A few simple rules that keep fines fun instead of contentious.',
    image: '/image1.jpg',
  },
  {
    tag: 'Updates',
    title: "What's new in Playfair this season",
    excerpt: "Recent features, fixes, and what's coming next.",
    image: '/image3.jpg',
  },
];

function BlogPage() {
  return (
    <>
      <Helmet>
        <title>Blog | Playfair</title>
        <meta name="description" content="Club stories, product updates, and tips from the Playfair team." />
        <link rel="canonical" href="https://playfair.online/resources/blog" />
      </Helmet>

      <OverlayHeroSection style={{ height: '70vh' }}>
        <OverlayHeroImage image={featuredPost.image} />
        <OverlayHeroGradient />
        <OverlayHeroContent>
          <BlogTag style={{ color: '#d1ff94' }}>{featuredPost.tag}</BlogTag>
          <h1
            style={{
              color: '#fff',
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              margin: '0.5rem 0 1rem',
              maxWidth: '700px',
            }}
          >
            {featuredPost.title}
          </h1>
          <p style={{ color: '#e5e7eb', maxWidth: '550px', fontSize: '1.1rem', marginBottom: '1.5rem' }}>
            {featuredPost.excerpt}
          </p>
          <BlogReadMore style={{ color: '#fff' }}>Read the full story →</BlogReadMore>
        </OverlayHeroContent>
      </OverlayHeroSection>

      <Section backgroundColor="#f0efea">
        <SectionContent>
          <SectionSubtitle style={{ color: '#1f2937', marginBottom: '1.5rem' }}>
            More From The Blog
          </SectionSubtitle>
          <BlogGrid>
            {posts.map((post) => (
              <BlogCard key={post.title} whileHover={{ y: -5 }}>
                <BlogImage image={post.image} />
                <BlogCardContent>
                  <BlogTag>{post.tag}</BlogTag>
                  <BlogCardTitle>{post.title}</BlogCardTitle>
                  <BlogCardExcerpt>{post.excerpt}</BlogCardExcerpt>
                  <BlogReadMore>Read more</BlogReadMore>
                </BlogCardContent>
              </BlogCard>
            ))}
          </BlogGrid>
        </SectionContent>
      </Section>
    </>
  );
}

export default BlogPage;
